import { createRecordApi } from "./createRecordApi";

export const createRecordSetData = async (
  lang,
  setMessageResponse,
  cookies,
  credintial,
  setSuccessMessage,
  setBtnLoader,
  userId
) => {
  const response = await createRecordApi(credintial, lang, cookies, userId);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "add",
      message: response.res.data.message,
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
